// import { tns } from "tiny-slider/src/tiny-slider.module.js";
import { tns } from "tiny-slider/src/tiny-slider.js";
const sliderBanners = document.querySelectorAll(".slider-banner");
if (sliderBanners) {
  sliderBanners.forEach(container => {
    // Array.foreach(banners, call ].forEach(container => {
    // Reveal the banner. Hiding during load is smart
    container.removeAttribute("hidden");
    // Pass optional options as data attributes
    let options = {
      container,
      mode: "gallery",
      // controlsPosition: "bottom",
      nav: false,
      // navPosition: "bottom",
      // autoplay: true,
      // autoplayTimeout: 4000,
      // autoplayButton: false,
      //  mouseDrag: true,
      prevButton: ".js-prev-slide",
      nextButton: ".js-next-slide"
    };
    if (container.getAttribute("data-autoplay")) {
      options.autoplay =
        container.getAttribute("data-autoplay") === "true" ? true : false;
    }
    if (container.getAttribute("data-autoplay-timeout")) {
      options.autoplayTimeout =
        parseInt(container.getAttribute("data-autoplay-timeout")) * 1000;
    }
    // Initialise with default options and their overrides
    tns(options);
  });
}
const sliderBrands = document.querySelectorAll(".slider-brands");
if (sliderBrands) {
  sliderBrands.forEach(container => {
    container.removeAttribute("hidden");
    // Pass optional options as data attributes
    let options = {
      container,
      mode: "carousel",
      controls: false,
      nav: false,
      autoplay: true,
      autoplayTimeout: 4000,
      speed: 3000,
      autoplayButton: false,
      mouseDrag: true,
      items: 3, // mobiles
      center: true, // horizontally only, sigh
      // gutter: 60 // uses scss instead
      responsive: {
        768: {
          items: 5
        }
      }
    };
    tns(options);
  });
}
const sliderTestimonials = document.querySelectorAll(".slider-testimonials");
if (sliderTestimonials) {
  sliderTestimonials.forEach(container => {
    container.removeAttribute("hidden");
    // Pass optional options as data attributes
    let options = {
      container,
      mode: "carousel",
      controls: false,
      nav: false,
      autoplay: true,
      autoplayTimeout: 6000,
      speed: 2000,
      autoplayButton: false,
      mouseDrag: true,
      items: 1, // mobiles
      responsive: {
        768: {
          items: 2
        }
      }
    };
    tns(options);
  });
}
const sliderRelatedProducts = document.querySelectorAll(
  ".slider-related-products"
);
if (sliderRelatedProducts) {
  sliderRelatedProducts.forEach(container => {
    container.style.display = "block";
    // Pass optional options as data attributes
    let options = {
      container,
      mode: "carousel",
      controls: false,
      nav: false,
      autoplay: true,
      autoplayTimeout: 6000,
      speed: 2000,
      autoplayButton: false,
      mouseDrag: true,
      items: 2, // mobiles
      responsive: {
        768: {
          items: 3
        },
        1300: {
          items: 4
        }
      }
    };
    tns(options);
  });
}
// Wack a wrapper class on overflowing style sliders
const sliderOverflows = document.querySelectorAll(".slider-overflow");
if (sliderOverflows) {
  sliderOverflows.forEach(container => {
    container.closest(".tns-ovh").classList.add("slider-overflow-wrapper");
  });
}
